import { DeleteTreaty, DeleteTreatyVariables } from "_graphql/mutation/__generated__/DeleteTreaty";
import { GenerateAndSendPNOC, GenerateAndSendPNOCVariables } from "_graphql/mutation/__generated__/GenerateAndSendPNOC";
import { deleteOffer, deleteTreaty, generateAndSendPNOC } from "_graphql/visal/mutations/offers";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { TreatyType } from "_graphql/__generated__/globalTypes";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function SendPNOCContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    GenerateAndSendPNOC,
    GenerateAndSendPNOCVariables
  >(generateAndSendPNOC, {
    refetchQueries: ["GetTreaties"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        treatyId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.generateAndSendPNOC) {
        toast.success("PNOC Sent Successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Could not send PNOC");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Send PNOC"
      variant="warning"
      cancelText="No, Don't Send PNOC"
      description="This action would send PNOC to all cedants"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Sending PNOC..." : "Send PNOC"}
          </button>
        </>
      )}
    />
  );
}
